module.exports = __webpack_public_path__ + "img/center_reight.e52d2c67.svg";